export default __webpack_public_path__ + "static/tether-c1d587669942a5e9bc47d677722878c2.png";